import { render } from "./BarcodeSearchPage.vue?vue&type=template&id=149a43b8&scoped=true"
import script from "./BarcodeSearchPage.vue?vue&type=script&lang=ts"
export * from "./BarcodeSearchPage.vue?vue&type=script&lang=ts"

import "./BarcodeSearchPage.vue?vue&type=style&index=0&id=149a43b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-149a43b8"

export default script